module.exports = __webpack_public_path__ + "static/media/SketchPnge75d179e51982c2c0ca7c30eca70cd14136f77e2292d42a3cf1ead2a5ef9eb01.638958ec.png";